module.exports = __webpack_public_path__ + "static/Albertsons_pin_hover-3ca2e275d66c9f62c012d131efc0a5d1.png";